import angular from 'angular';
import _ from "lodash";

class divisionDetailsCtrl {
    /* @ngInject */
    constructor(
        $uibModal,
        $state,
        AuthSvc,
        logger,
        $translate,
        $filter,
        $window,
        PrincipalSvc,
        SessionSvc
    ) {
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.AuthSvc = AuthSvc;
        this.logger = logger;
        this.$translate = $translate;
        this.$filter = $filter;
        this.$window = $window;
        this.PrincipalSvc = PrincipalSvc;
        this.SessionSvc = SessionSvc;
    }

    $onInit() {
        this.resetSubEntity = _.cloneDeep(this.division);
        this.subEntityDto = this.division;
        this.countryCode = this.subEntityDto.countryCode;
        if (this.countryCode) {
            this.countryLabel = this.$translate.instant('country.' + angular.lowercase(this.countryCode));
        }
        this.typeLiaison = [
            {code: "RVA"},
            {code: "MAIL"}
        ]
        this.isLiaisonPrincipale = !!this.subEntityDto.diagMainLinkType;
        this.isLiaisonSecondaire = !!this.subEntityDto.diagSecondaryLinkType;
        this.isLiaisonPrincipaleInitial = _.cloneDeep(this.isLiaisonPrincipale);
        this.isLiaisonSecondaireInitial = _.cloneDeep(this.isLiaisonSecondaire);
        this.editDisabled = !this.isEditAuthorized();
        this.hasNotSupportRole = !this.SessionSvc.getCurrentUser().roles.includes('SUPPORT');
        var defaultCellTemplateUpload =
            '<div class="grid-cell-link text-center"> <div ng-click="grid.appScope.$ctrl.getCgvPdf(row.entity.id)">{{COL_FIELD CUSTOM_FILTERS}}' +
            '<i class="fa fa-download"></i></div></div>';

        var defaultCellTemplateDelete =
            '<div class="grid-cell-link text-center"> <div ng-click="grid.appScope.$ctrl.deleteCgvDoc(row.entity.id)">{{COL_FIELD CUSTOM_FILTERS}}' +
            '<i class="fa fa-trash"></i></div></div>';

        // Tableau CGV
        this.cgvGridOptions = {
            columnDefs: [
                {
                    name: 'documentVersion',
                    displayName: 'Référence',
                    width: '33%',
                    cellClass: 'justify-content-center',
                },
                {
                    name: 'applicationDate',
                    displayName: "Date début d'application",
                    width: '33%',
                    cellClass: 'justify-content-center',
                },
                {
                    name: 'documentId',
                    displayName: 'Télécharger',
                    cellTemplate: defaultCellTemplateUpload,
                    width: '28%',
                    cellClass: 'pointer justify-content-center',
                },
                {
                    name: 'documentId1',
                    displayName: '',
                    cellTemplate: defaultCellTemplateDelete,
                    width: '6%',
                    cellClass: 'pointer justify-content-center',
                    visible : !this.hasNotSupportRole || !this.editDisabled,
                },
            ],
            exporterOlderExcelCompatibility: false,
            enableRowSelection: false,
            enableSelectAll: false,
            useExternalPagination: false,
            useExternalSorting: false,
            enableInfiniteScroll: false,
            enableGridMenu: false,
            enableHorizontalScrollbar: 0,
            enableVerticalScrollbar: 0,
            enableSorting: false,
            enableColumnMenus: false,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
            },
            data: this.subEntityCgv,
        };

        if(this.cgvGridOptions.columnDefs[3].visible === false){
            this.cgvGridOptions.columnDefs[2].width = '34%'
        }
    }

    checkIfEmpty() {
        if (this.subEntityDto.diagMainLinkType === '' || !angular.isDefined(this.subEntityDto.diagMainLinkType)) {
            this.isLiaisonPrincipale = false
            this.liaisonPrincipale();
        }
    }

    liaisonPrincipale() {
        if (!this.isLiaisonPrincipale) {
            this.subEntityDto.diagMainLinkType = null;
            this.subEntityDto.diagMainLinkValue = null;
            this.subEntityDto.diagSecondaryLinkType = null;
            this.subEntityDto.diagSecondaryLinkValue = null;
            this.isLiaisonSecondaire = false;
        }
    }

    liaisonSecondaire() {
        if (!this.isLiaisonSecondaire) {
            this.subEntityDto.diagSecondaryLinkType = null;
            this.subEntityDto.diagSecondaryLinkValue = null;
        }
    }

    emptyLiaisonSecondaire() {
        if (!angular.isDefined(this.subEntityDto.diagMainLinkValue)) {
            this.isLiaisonSecondaire = false
            this.subEntityDto.diagSecondaryLinkType = null;
            this.subEntityDto.diagSecondaryLinkValue = null;
        }
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }

    back() {
        this.$window.history.back();
    }

    cancel() {
        this.subEntityDto = _.cloneDeep(this.resetSubEntity);
        this.isLiaisonPrincipale = _.cloneDeep(this.isLiaisonPrincipaleInitial);
        this.isLiaisonSecondaire = _.cloneDeep(this.isLiaisonSecondaireInitial);
    }

    save() {
        if (this.form.$valid) {
            this.PrincipalSvc.updateSubEntity(this.subEntityDto).then(
                data => {
                    this.logger.success('success.update', data, null, {
                        entityName: "La division",
                    });

                },
                error => {
                    this.logger.error('error.update', error);
                }
            );
        }
    }

    getGridHeight() {
        var rowHeight = 30;
        return {
            height: this.gridApi.core.getVisibleRows(this.gridApi.grid).length * rowHeight + 30 + 'px',
        };
    }

    //permet d'ouvrir la pop-up pour ajouter un nouveau document cgv
    addNewCGV() {
        this.$uibModal
            .open({
                component: 'modalCgvImportComponent',
                size: 'md',
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    subEntityId: () => this.division.id,
                },
            })
            .closed.then(() => {
            this.PrincipalSvc.getCgvOfSubEntity(this.division.id).then(subEntityCgv => {
                this.cgvGridOptions.data = subEntityCgv;
                this.subEntityCgv = subEntityCgv;
            });
        });
    }

    deleteCgvDoc(documentId) {
        this.PrincipalSvc.deleteCgvDoc(documentId).then(
            data => {
                this.logger.success('CGV supprimé avec succès', data);
                this.PrincipalSvc.getCgvOfSubEntity(this.division.id).then(subEntityCgv => {
                    this.cgvGridOptions.data = subEntityCgv;
                    this.subEntityCgv = subEntityCgv;
                });
            },
            error => {
                this.logger.error('erreur lors de la suppression des cgv', error);
            }
        );
    }

    getCgvPdf(documentId) {
        this.PrincipalSvc.getCgvPdf(documentId).then(
            data => {
                this.logger.success('CGV téléchargé avec succès', data);
            },
            error => {
                this.logger.error('Erreur de téléchargement du CGV', error);
            }
        );
    }

}

angular.module('app.principal').component('divisionDetails', {
    templateUrl: require('./division-details.html'),
    controller: divisionDetailsCtrl,
    bindings: {
        division: '<',
        subEntityCgv: '<',
    },
});
